import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const planningService = {
  getAllPlannings,
  getPlanningById,
  deletePlanning,
  updatePlanning,
  createPlanning,
  requestPlanning,
  getAllUsersPlannings,
  getFramePanelsByPlanningId,
  duplicatePlanning,
  getSearchHistory,
  getFramePanelsByHistoryId,
  deleteSearchRecord,
  planningSearchOrFilter,
  saveSearch,
  changeState,
  getPlanningsByCampaignId,
  getPanelSuggestions,
  getPanelsSuggestionsNoPagination,
};

const { apiUrl, apiVer } = defineConfig.PLANNING_SERVICE;

function getApiPath() {
  return (apiUrl + apiVer + "/planning");
}

function getFramePanelApiPath() {
  return (apiUrl + apiVer + "/planning/framePanel");
}

function getSearchApiPath() {
  return (apiUrl + apiVer + "/planning/search");
}

function getSearchHistory(id) {
  const url = getSearchApiPath() + `/all/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteSearchRecord(id) {
  const url = getSearchApiPath() + `/delete/` + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function planningSearchOrFilter(planningObj = {}) {
  const url = getSearchApiPath() + `/create`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(planningObj),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPanelSuggestions(searchTerm, searchField, page = 0, size = 20, sortBy = "createdAt", sortDir = "desc", type = "ALL", planningId, filters = {}) {
  const url = getSearchApiPath() + `/all/suggestion?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}&planningId=${planningId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getPanelsSuggestionsNoPagination(searchTerm, searchField, type = "ALL", planningId, filters = {}) {
  const url = getSearchApiPath() + `/all/suggestion/map?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&type=${type}&planningId=${planningId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFramePanelsByHistoryId(id) {
  const url = getSearchApiPath() + `/all/history/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getFramePanelsByPlanningId(id) {
  const url = getFramePanelApiPath() + `/all/planning/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllPlannings(page, pageSize = 10, filters = {}, sorter = {}) {
  let queryParams = [];
  let sortType = sorter.order === 'descend' ? 'desc' : 'asc';
  let sortValue = sorter.field || "creationDate"

  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/" + page + "/" + pageSize + "/" + sortValue + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPlanningById(id) {
  const url = getApiPath() + `/read/` + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deletePlanning(id) {
  const url = getApiPath() + `/delete/` + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updatePlanning(id, body) {
  const url = getApiPath() + `/update/` + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function createPlanning(body, type) {
  const url = getApiPath() + `/create`;

  const formattedBody = {
    ...body,
    type: type,
  };

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(formattedBody),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function requestPlanning(campaign, plannerId = null) {
  const url = getApiPath() + `/create/request`;

  const formattedBody = {
    ...campaign,
    plannerId,
  };

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(formattedBody),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllUsersPlannings() {
  const url = getApiPath() + "/all/owner";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function duplicatePlanning(planningId, campaignId) {
  const url = getApiPath() + `/read/duplicate/` + planningId + "&campaign=" + campaignId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function saveSearch(planningId, frameIds) {
  const url = getApiPath() + "/update/" + planningId + "/system";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameIds),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function changeState(id) {
  const url = getApiPath() + "/update/" + id + "/state";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getPlanningsByCampaignId(campaignId) {
  const url = getApiPath() + `/all/campaign/` + campaignId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}